import React from 'react';
import './App.css';
import Input from './Input.jsx'
import Output from './Output.jsx'
import marked from 'marked';
import {placeholder} from './placeholder.js';

marked.setOptions({
  breaks: true,
});

export default class App extends React.Component {
  constructor (props){
    super (props);
    this.state = {
       input: placeholder,
       output: marked(placeholder),
       
    }
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(ev){
    ev.persist();
    this.setState( state => ({
      input: ev.target.value,
      output: marked(ev.target.value),
      
    })
    )
  }

    render(){
      document.body.style.background = "#00bd87";
      return (
          <div className="App">
            <Input input={this.state.input} change={this.handleChange}/>
            <Output output={this.state.output}/>
            <div className="sign">By KaiserP</div>
          </div>
      )
    }
  }

  